export function Hemato() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 13.9629C19 17.8289 15.866 20.9629 12 20.9629C8.13401 20.9629 5 17.8289 5 13.9629C5 10.0969 12 2.96289 12 2.96289C12 2.96289 19 10.0969 19 13.9629Z"
        fill="#D0D3DC"
      />
    </svg>
  );
}
